<div mat-dialog-title>
  <h2>{{'restaurant.Photos & Videos' | translate}}</h2>
  <button mat-icon-button class="close" (click)="openConfirmDialog()">
      <mat-icon class="pop-close">close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <div *ngIf='dataLoading' class="dataLoading">
    <mat-spinner class="m-auto" diameter="50"></mat-spinner>
  </div>

  <div *ngIf="!dataLoading" class="mat-dialog-body">

    <div class="fields-group">
      <div class="sub-title">{{"content2.Photos" | translate}}</div>

      <app-photo-manager
        (selectedFiles)="photos = $event"
        [files]="photos"
        [managerIndex]="1"
        [isSubmitted]="isSubmitted"
        [allowedExt]="data.galleryData.acceptableExstensionsImage"
        [maxFiles]="data.galleryData.maxImagesFilesPerOnce"
        [maxFileSize]="data.galleryData.imageMaxSize"
      ></app-photo-manager>
    </div>

    <div class="fields-group">
      <div class="sub-title">{{"content2.Videos" | translate}}</div>

      <app-video-manager
        (selectedFiles)="videos = $event"
        [files]="videos"
        [managerIndex]="2"
        [isSubmitted]="isSubmitted"
        [allowedExt]="data.galleryData.acceptableExstensionsVideos"
        [maxFiles]="data.galleryData.maxVideosFilesPerOnce"
        [maxFileSize]="data.galleryData.videoMaxSize"
      ></app-video-manager>
    </div>

    <p class="has-error" *ngIf="isSubmitted && !(this.photos.length || this.videos.length)">
      {{ "content2.Please add photos or videos" | translate }}
    </p>

  </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button class="btn-grey" (click)="openConfirmDialog()">
      {{"forms.Cancel" | translate}}
    </button>
    <button mat-raised-button color="primary"
      [disabled]="loading"
      [class.loading]="loading"
      (click)="saveRecord()">
        {{"forms.Save" | translate}}
    </button>
</mat-dialog-actions>
